"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
// eslint-disable-next-line max-statements, complexity
const widgets = (state = {}, action) => {
    switch (action.type) {
        case 'SURVEY_SET_INITED':
        case 'SURVEY_LOADED_FROM_CONFIG': {
            const payloadWidgets = action.data.widgets || {};
            const widgets = {};
            Object.keys(payloadWidgets).forEach(id => {
                widgets[id] = Object.assign(Object.assign({}, payloadWidgets[id]), { visible: true, isValid: !payloadWidgets[id].hasTimeLimit });
            });
            return widgets;
        }
        case 'NODE_VISIBILITY_CHANGED': {
            const newState = (0, cloneDeep_1.default)(state);
            action.nodes.forEach(node => {
                switch (node.type) {
                    case 'widget': {
                        newState[node.id].visible = node.state;
                        break;
                    }
                    default:
                }
            });
            return newState;
        }
        case 'WIDGET_COMPLETED': {
            const newState = (0, cloneDeep_1.default)(state);
            newState[action.widgetId].isValid = true;
            return newState;
        }
        default:
            return state;
    }
};
exports.default = widgets;
